









































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class IconGuidanceText extends Vue {
  @Prop({ default: false })
  light!: boolean;

  @Prop({ default: false })
  dark!: boolean;

  private attensiColor = '#56BCCF';
  private backgroundLightColor = '#DEDEE1';

  getTextColor() {
    if (this.dark) {
      return this.attensiColor;
    }
    if (this.light) {
      return this.backgroundLightColor;
    }
    return this.attensiColor;
  }
}
